// extracted by mini-css-extract-plugin
export default {"root":"Placeholder__root--2GBye","keyframes-pulse":"Placeholder__keyframes-pulse--3XdyN"};